export default {
    props: ['value', 'secondary', 'error', 'autofocus', 'code', 'title'],

    data() {
        return {
            type: 'input'
        }
    },

    mounted() {
		if (this.autofocus && this.$refs.input)
			setTimeout(() => {
				this.$refs.input.focus()
			}, 100)
	},

    methods: {
        change() {
            this.$emit('input', this.$refs.input.value)
            this.$emit('reset')
		},
        enter() {
			this.change()
			this.primaryNext()
		},
        primaryNext() {
            this.$emit('next')
        },
        secondaryNext() {
            this.$emit('secondary')
        }
    }
}
